import { useContext, useMemo, useState } from "react"
import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import Typography from "components/styled/Typography"
import { sendEvent } from "scripts/GoogleAnalytics"
import Icon from "components/icons/icon"
import Arrow from "components/icons/arrow"
import { color } from "helpers/styled"
import LazyLoad from "react-lazyload"
import Plan from "../../Plans/Plan"
import { CarContext } from "../../CarContext"

const Body = styled.div`
  background: ${color("white")};
  padding-bottom: 25px;

  .selected {
    display: none;
  }
`

const StyledIcon = styled(Icon)`
  margin-top: 25px;
  transform: rotate(90deg);
  transition: transform 0.25s ease-out;

  &.active {
    transform: rotate(-90deg);
    transition: transform 0.25s ease-in;
  }
`

const MoreButton = styled.div`
  text-align: center;
  margin: 0 auto;
  width: fit-content;
`

function PlanList() {
  const t = useT()
  const { car, page, plans, selectedPlan, withoutTaxes } = useContext(CarContext)
  const { id } = car
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    sendEvent("Click CTA plans", { event_category: page, event_label: isOpen ? "Less plans" : "More plans" })
    setIsOpen(!isOpen)
  }

  const plansNotSelected = useMemo(() => plans.filter(plan => plan !== selectedPlan), [plans, selectedPlan])

  return (
    <LazyLoad once>
      {plansNotSelected.length > 0 && (
        <Body className={isOpen ? "show-all" : null}>
          {plansNotSelected.map(plan => (
            <Plan key={plan.id} carId={id} plan={plan} withoutTaxes={withoutTaxes} small />
          ))}
          {plansNotSelected.length > 5 && (
            <MoreButton onClick={toggle} css="text-align: center">
              <StyledIcon color="deepPink" className={isOpen ? "active" : null} Icon={Arrow} />
              <Typography variant="small">
                {t(`car_data.plans.${isOpen ? "show_less" : "show_more"}`, { count: plans.length - 5 })}
              </Typography>
            </MoreButton>
          )}
        </Body>
      )}
    </LazyLoad>
  )
}

export default PlanList
